import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import ReactMarkdown from 'react-markdown';

import termsText from './termsAndConditoinsText';

import agreementsRemote from '../../api/agreementsRemote'

import ConfirmationDialog from '../confirmation/ConfirmationDialog';
import { closeTermsModal } from '../../store/actions/termsAndConditionsModalAction';
import ApiResponse from '../../models/ApiResponse';
import ResponseError from '../../models/ResponseError';
import { logoutAction } from '../../store/actions/loginAction';

interface TermsAndConditionsModalContainerState { };

interface TermsAndConditionsModalContainerProps  {
  termsAndConditionsModal: {opened: boolean, informativeMode?: boolean};
  closeModal: () => void;
  logout: () => void;
  informativeMode?: boolean;
};

class TermsAndConditionsModalContainer extends Component <TermsAndConditionsModalContainerProps, TermsAndConditionsModalContainerState> {

  declineTermsAndConditions() {
    this.props.logout();
    this.props.closeModal();
  }

  agreeWithTermsAndConditions() {
    agreementsRemote.agreeWithTermsAndConditions().then((resp: ApiResponse<undefined>) => {

      const error: ResponseError | undefined = resp.error;

      if (error) {
        this.props.logout();
      };

      this.props.closeModal();
    });
  }

  render() {
    if(this.props.termsAndConditionsModal.informativeMode) {
    return (
      <ConfirmationDialog 
        title='Terms and conditions' 
        text={<ReactMarkdown source={termsText} />}
        open={this.props.termsAndConditionsModal.opened}
        close={() => this.props.closeModal()}
        confirm={() => this.props.closeModal()}
        textConfirm='Close'
        maxWidth='xl'
        showCloseIcon={true}
        showCancelButton={false}
        />
      );
    } else {
    return (
        <ConfirmationDialog 
          title='Update in terms and conditions' 
          text={<ReactMarkdown source={termsText} />}
          open={this.props.termsAndConditionsModal.opened}
          close={() => this.declineTermsAndConditions()}
          confirm={() => this.agreeWithTermsAndConditions()}
          textConfirm='Agree'
          textCancel='Decline'
          maxWidth='xl'
          showCloseIcon={false}
          showCancelButton={true}
        />
      );
    }
  }
};

const mapStateToProps = (state: any) => {
  return {
    termsAndConditionsModal: state.termsAndConditionsModal
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    closeModal: () => dispatch(closeTermsModal()),
    logout: () => dispatch(logoutAction())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TermsAndConditionsModalContainer);